import React, { useState } from "react";
import {
  getRememberSignin,
  setRememberSignin,
  setSession,
  validSession,
} from "../../bandung";
import { sessionSignin } from "../../api/session";
import useTextField from "../../hooks/useTextField";
import { Paper, styled } from "@mui/material";
import SigninHeader from "./SigninHeader";
import SigninForm from "./SigninForm";
import { Navigate, useLoaderData } from "react-router-dom";

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: clamp(280px, 100%, 440px);
  height: 100%;
  padding: 3em 0;
`;

const signinComponentLoader = ({ request }) => {
  const url = new URL(request.url);
  const searchParams = url.searchParams;
  const message = searchParams.get("message");
  const redirect = searchParams.get("redirect");
  return { message, redirect };
};

const SigninComponent = ({
  header,
  navigateAwayPath,
  ...props
}) => {
  const email = useTextField(getRememberSignin() ?? "");
  const password = useTextField();
  const [remember, setRemember] = useState(!!getRememberSignin());
  const loaderData = useLoaderData();

  const handleSignin = async () => {
  // console.log("Attempting login with:", email.value, password.value);
  const response = await sessionSignin(email.value, password.value);
  console.log("Login response:", response);

  if (response.code === "SUCCESS") {
    console.log("Setting session:", response.data);
    setSession(response.data);
    setRememberSignin(remember ? email.value : null);
    const newPath = loaderData.redirect ?? navigateAwayPath ?? "/";
    window.history.replaceState({}, document.title, newPath);
    window.location.href = newPath;
  } else {
    console.log("Login failed:", response.message);
    email.alertError();
    password.alertError(response.message);
  }
};

  const handleEmailChange = (event) => {
    email.setValue(event.target.value);
    resetErrors();
  };

  const handlePasswordChange = (event) => {
    password.setValue(event.target.value);
    resetErrors();
  };

  const handleRememberChange = (event) => {
  const isChecked = event.target.checked;
  setRemember(isChecked);
  if (!isChecked) {
    setRememberSignin(null);
  } else {
    setRememberSignin(true);
  }
};

  const resetErrors = () => {
    email.resetError();
    password.resetError();
  };

  if (validSession()) return <Navigate
    to={loaderData.redirect ?? navigateAwayPath}
    replace
  />;

  return (
    <StyledPaper {...props}>
      <SigninHeader children={header}/>
      <SigninForm
        email={email}
        onEmailChange={handleEmailChange}
        password={password}
        onPasswordChange={handlePasswordChange}
        remember={remember}
        onRememberChanged={handleRememberChange}
        message={loaderData.message}
        onSigninSubmit={handleSignin}
      />
    </StyledPaper>
  );
};

export { signinComponentLoader };
export default SigninComponent;